import { ContentCatalogFolder } from "@models/contentCatalogFolder.model";

type OwnedFolder = Pick<ContentCatalogFolder, "organization_id" | "organization_name">;

/**
 * The owning sub-org's name, when a folder was rolled up from beneath the org on screen.
 *
 * A listing covers the requested org and its sub-orgs (MPN-1921), and sub-orgs routinely
 * reuse folder names — four "Migrated Content" roots under one parent is the normal case.
 * Null once the org on screen owns the folder, so a single-org catalog stays unlabelled.
 */
export function borrowedOwnerName(
    folder: OwnedFolder,
    viewedOrganizationId: number | null,
): string | null {
    if (!folder.organization_name || folder.organization_id == null) return null;
    return folder.organization_id === viewedOrganizationId ? null : folder.organization_name;
}
